import type { Components } from '@mui/material/styles';

export default function MUIToolbar(): Components['MuiToolbar'] {
  return {};
}
